var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sv",attrs:{"id":"sv"}},[(this.streetViewCamera.position === null)?_c('div',{attrs:{"id":"sv-hint"}},[_c('span',[_vm._v(" CTRL+Click anywhere on the map (CMD+Click on MacOS) to set Street View position ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }